import React, { useState } from 'react';
import axios from 'axios';
import { requestID, baseUrl, config } from '../common/utils';
import { IonPage } from '@ionic/react';
 
const PerformanceAnalyzer = ({ token }) => {
  const [scores, setScores] = useState('');
  const [analysis, setAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setAnalysis(null);

    try {
      const scoresArray = scores.split(',').map(score => parseFloat(score.trim())).filter(score => !isNaN(score));
      
      if (scoresArray.length === 0) {
        setError('Please enter valid scores');
        return;
      }

      const payload = {
        requestID: requestID(),
        scores: scoresArray
      };
      
      const res = await axios.post(
        `${baseUrl()}performance/analyze`,
        payload,
        config
      );

      if (res.data.success) {
        setAnalysis(res.data.result);
      }
    } catch (error) {
      setError('Failed to analyze scores');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage className="performance-analyzer">
      <h2>Performance Score Analyzer</h2>
      
      <form onSubmit={handleSubmit}>
        <div>
          <label>Enter scores (comma-separated):</label>
          <input
            type="text"
            value={scores}
            onChange={(e) => setScores(e.target.value)}
            placeholder="e.g., 8, 7, 9, 6, 8.5"
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Analyzing...' : 'Analyze Scores'}
        </button>
      </form>

      {error && <div className="error">{error}</div>}

      {analysis && (
        <div className="analysis-results">
          <h3>Analysis Results</h3>
          <p><strong>Average Score:</strong> {analysis.average}</p>
          <p><strong>Highest Score:</strong> {analysis.highest}</p>
          <p><strong>Lowest Score:</strong> {analysis.lowest}</p>
          <p><strong>Total Scores:</strong> {analysis.count}</p>
          <p><strong>Performance Level:</strong> {analysis.performance_level}</p>
          
          {analysis.trend && (
            <p><strong>Trend:</strong> {analysis.trend}</p>
          )}
        </div>
      )}
    </IonPage>
  );
};

export default PerformanceAnalyzer;